import { List, Record } from 'immutable';
import FilterDefinitionTypeConstants from '~/constants/filter-definition-type-constants';
import FilterDefinitionValueRecord from '~/ducks/machine-filter-v2/data/FilterDefinitionValueRecord';
import NameRecord from '~/ducks/machine-filter-v2/data/NameRecord';
import formatMessageWrapper from '~/utils/format-message-wrapper/format-message-wrapper';
import {
  baseKeys,
  FilterDefinitionTypeBaseFields,
  FilterDefinitionTypeMethods,
} from './FilterTypeDefinitionBase';

const keys: Fields = {
  ...baseKeys,
  options: List(),
  type: FilterDefinitionTypeConstants.MULTI_SELECT,
};

export interface Fields extends FilterDefinitionTypeBaseFields {
  options: List<FilterDefinitionValueRecord>;
  type: FilterDefinitionTypeConstants.MULTI_SELECT;
}

export default class SelectFilterDefinitionTypeRecord
  extends Record<Fields>(keys)
  implements FilterDefinitionTypeMethods {
  constructor(values?) {
    super(values);

    const newValues: Partial<Fields> = {};

    if (values) {
      if (values.options) {
        newValues.options = List(
          values.options.map(
            (option) => new FilterDefinitionValueRecord(option)
          )
        );
      }

      if (values.name) {
        newValues.name = new NameRecord(values.name);
      }
    }

    return this.merge(newValues);
  }

  getFilterKey(): string {
    return this.name.getName();
  }

  getOptions(): List<FilterDefinitionValueRecord> {
    return this.options;
  }

  getTranslationKey(): string {
    return this.name.getTranslationKey() || '';
  }

  getLabel(): string | undefined {
    return this.name.getLabel();
  }

  getName(): string {
    return this.name.getName();
  }

  getNameRecord(): NameRecord {
    return this.name;
  }

  getType() {
    return this.type;
  }

  getFormattedFilterName(): string {
    return formatMessageWrapper(this.getTranslationKey());
  }
}
